import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

import { AppStrings } from "../../../../utils/constants/AppStrings";
import { formatString } from "../../../../utils/constants/stringUtils";
import ToggleSwitch from "../../ToggleSwitch/ToggleSwitch";
import styles from "./ConfigurableDataTable.module.css";

function DragHandleIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
      {[4, 8, 12].flatMap((cy) => [
        <circle key={`left-${cy}`} cx="5" cy={cy} r="1.3" />,
        <circle key={`right-${cy}`} cx="11" cy={cy} r="1.3" />,
      ])}
    </svg>
  );
}

function SortableColumnRow({ column, visible, onVisibilityChange }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: column.key });

  return (
    <div
      ref={setNodeRef}
      className={`${styles.columnRow} ${isDragging ? styles.columnRowDragging : ""}`}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
      }}
      data-testid={`configurable-column-${column.key}`}
    >
      <button
        type="button"
        className={styles.dragHandle}
        aria-label={formatString(
          AppStrings.PAM_CONFIGURABLE_TABLE_REORDER_COLUMN,
          { column: column.label },
        )}
        {...attributes}
        {...listeners}
      >
        <DragHandleIcon />
      </button>
      <ToggleSwitch
        value={visible}
        onChange={(next) => onVisibilityChange(column.key, next)}
        ariaLabel={column.label}
      />
      <span className={styles.columnLabel}>{column.label}</span>
    </div>
  );
}

export default SortableColumnRow;
